export const ColorSchemes = {
    white: {
        BackgroundColor: '#ffffff',
        HeaderColor: '#2C3345',
        SubheaderColor: '#2C3345',
        HeadingBorderColor: '#e6e6e6',
        LabelColor: '#2C3345',
        SublabelColor: '#000',
        RequiredColor: '#f00',
        PlaceholderColor: '#b9b9b9',
        InputColor: '#000',
        InputBorderColor: '#dfdfdf',
        TextColor: '#2C3345',
        InputBackgroundColor: '#fff',
        InputBackgroundColor2: '#f4f4f4',
        InputIconColor: '#737373',
        ButtonTextColor: '#ffffff',
        ButtonBackgroundColor: '#18bd5b',
        ButtonBorderColor: '#18bd5b',
    },
    dark: {
        BackgroundColor: '#424756',
        HeaderColor: '#FFFFFF',
        SubheaderColor: 'rgba(255,255,255,.8)',
        HeadingBorderColor: 'rgba(255,255,255,0.1)',
        LabelColor: '#fff',
        SublabelColor: 'rgba(255,255,255,.8)',
        RequiredColor: '#f00',
        PlaceholderColor: 'rgba(0,0,0,.8)',
        InputColor: '#424756',
        InputBorderColor: '#dfdfdf',
        TextColor: '#FFF',
        InputBackgroundColor: '#fff',
        InputBackgroundColor2: '#2f3649',
        InputIconColor: '#737373',
        ButtonTextColor: '#ffffff',
        ButtonBackgroundColor: '#2E69FF',
        ButtonBorderColor: '#2E69FF',
    },
    blue: {
        BackgroundColor: '#E4EFFF',
        HeaderColor: '#12458D',
        SubheaderColor: 'rgba(17,69,141,.75)',
        HeadingBorderColor: 'rgba(17,69,141,0.1)',
        LabelColor: '#12458D',
        SublabelColor: 'rgba(17,69,141,.75)',
        RequiredColor: '#f00',
        PlaceholderColor: 'rgba(0,0,0,.35)',
        InputColor: '#12458D',
        InputBorderColor: '#93b8ec',
        TextColor: '#12458D',
        InputBackgroundColor: '#fff',
        InputBackgroundColor2: '#c4d6f1',
        InputIconColor: '#737373',
        ButtonTextColor: '#ffffff',
        ButtonBackgroundColor: '#12458D',
        ButtonBorderColor: '#12458D',
    },
    azure: {
        BackgroundColor: '#3595F6',
        HeaderColor: '#FFF',
        SubheaderColor: 'rgba(255,255,255,.8)',
        HeadingBorderColor: 'rgba(255,255,255,0.1)',
        LabelColor: '#FFF',
        SublabelColor: 'rgba(255,255,255,.8)',
        RequiredColor: '#F69635',
        PlaceholderColor: 'rgba(0,0,0,.25)',
        InputColor: '#12458D',
        InputBorderColor: '#93b8ec',
        TextColor: '#FFF',
        InputBackgroundColor: '#fff',
        InputBackgroundColor2: '#1c7ad9',
        InputIconColor: '#737373',
        ButtonTextColor: '#ffffff',
        ButtonBackgroundColor: '#F69635',
        ButtonBorderColor: '#F69635',
    },
    orange: {
        BackgroundColor: '#FFDF79',
        HeaderColor: '#571700',
        SubheaderColor: '#571700',
        HeadingBorderColor: 'rgba(150,40,0,.1)',
        LabelColor: '#571700',
        SublabelColor: '#571700',
        RequiredColor: '#f00',
        PlaceholderColor: 'rgba(0,0,0,.65)',
        InputColor: '#571700',
        InputBorderColor: '#571700',
        TextColor: '#571700',
        InputBackgroundColor: '#fff',
        InputBackgroundColor2: '#e5c352',
        InputIconColor: '#737373',
        ButtonTextColor: '#ffffff',
        ButtonBackgroundColor: '#6A1B00',
        ButtonBorderColor: '#6A1B00',
    },
    brown: {
        BackgroundColor: '#EFE8D4',
        HeaderColor: '#321F16',
        SubheaderColor: 'rgba(50,31,22,0.75)',
        HeadingBorderColor: 'rgba(150,40,0,.1)',
        LabelColor: '#321F16',
        SublabelColor: 'rgba(50,31,22,0.75)',
        RequiredColor: '#f00',
        PlaceholderColor: 'rgba(0,0,0,.65)',
        InputColor: '#321F16',
        InputBorderColor: '#321F16',
        TextColor: '#321F16',
        InputBackgroundColor: '#fff',
        InputBackgroundColor2: '#d4ccb5',
        InputIconColor: '#737373',
        ButtonTextColor: '#ffffff',
        ButtonBackgroundColor: '#321F16',
        ButtonBorderColor: '#321F16',
    },
    lime: {
        BackgroundColor: '#F4FFDF',
        HeaderColor: '#455429',
        SubheaderColor: 'rgba(69,84,41,0.75)',
        HeadingBorderColor: 'rgba(69,84,41,0.1)',
        LabelColor: '#455429',
        SublabelColor: 'rgba(69,84,41,0.75)',
        RequiredColor: '#f00',
        PlaceholderColor: 'rgba(0,0,0,.5)',
        InputColor: '#455429',
        InputBorderColor: '#455429',
        TextColor: '#455429',
        InputBackgroundColor: '#fff',
        InputBackgroundColor2: '#ddefba',
        InputIconColor: '#737373',
        ButtonTextColor: '#ffffff',
        ButtonBackgroundColor: '#455429',
        ButtonBorderColor: '#455429',
    },
    green: {
        BackgroundColor: '#2dcb89',
        HeaderColor: '#006666',
        SubheaderColor: '#006666',
        HeadingBorderColor: '#006666',
        LabelColor: '#006666',
        SublabelColor: '#006666',
        RequiredColor: '#ff0088',
        PlaceholderColor: 'rgba(0,0,0,.5)',
        InputColor: '#006666',
        InputBorderColor: '#006666',
        TextColor: '#006666',
        InputBackgroundColor: '#2dcb89',
        InputBackgroundColor2: '#27b278',
        InputIconColor: '#737373',
        ButtonTextColor: '#ffffff',
        ButtonBackgroundColor: '#76163D',
        ButtonBorderColor: '#76163D',
    },
    violet: {
        BackgroundColor: '#F7F2FF',
        HeaderColor: '#412A68',
        SubheaderColor: '#412A68',
        HeadingBorderColor: '#412A68',
        LabelColor: '#412A68',
        SublabelColor: '#412A68',
        RequiredColor: '#ff0088',
        PlaceholderColor: 'rgba(0,0,0,.5)',
        InputColor: '#412A68',
        InputBorderColor: '#412A68',
        TextColor: '#412A68',
        InputBackgroundColor: '#FFF',
        InputBackgroundColor2: '#ede7f8',
        InputIconColor: '#737373',
        ButtonTextColor: '#ffffff',
        ButtonBackgroundColor: '#412A68',
        ButtonBorderColor: '#412A68',
    },
    red: {
        BackgroundColor: '#df6659',
        HeaderColor: '#521e18',
        SubheaderColor: '#521e18',
        HeadingBorderColor: '#521e18',
        LabelColor: '#521e18',
        SublabelColor: '#521e18',
        RequiredColor: '#ff0088',
        PlaceholderColor: 'rgba(82,30,24,0.5)',
        InputColor: '#521e18',
        InputBorderColor: '#521e18',
        TextColor: '#521e18',
        InputBackgroundColor: '#df6659',
        InputBackgroundColor2: '#e37a6f',
        InputIconColor: '#737373',
        ButtonTextColor: '#ffffff',
        ButtonBackgroundColor: '#521e18',
        ButtonBorderColor: '#521e18',
    },
    pink: {
        BackgroundColor: '#FFF8FA',
        HeaderColor: '#962D53',
        SubheaderColor: '#962D53',
        HeadingBorderColor: '#962D53',
        LabelColor: '#962D53',
        SublabelColor: '#962D53',
        RequiredColor: '#ff0088',
        PlaceholderColor: 'rgba(82,30,24,0.5)',
        InputColor: '#962D53',
        InputBorderColor: '#962D53',
        TextColor: '#962D53',
        InputBackgroundColor: '#FFF',
        InputBackgroundColor2: '#f7e8ed',
        InputIconColor: '#737373',
        ButtonTextColor: '#ffffff',
        ButtonBackgroundColor: '#962D53',
        ButtonBorderColor: '#962D53',
    }
}